module.exports = __webpack_public_path__ + "img/logo.273f3148.png";